module.exports = __webpack_public_path__ + "img/ywAward-5.6b3bb37c.png";